import type {
  Facilities,
  StudioFacilities,
} from '@bond/bruce-api/common/facility'

export function modifyStudioPartnerSignup(
  event: FormDataEvent,
  facilities: Facilities,
  oldFacilities: StudioFacilities,
) {
  // Format facilities
  const activeFacilities = facilities
    .map((facility) =>
      event.formData.get(`facility_${facility.code}`) === 'true'
        ? facility
        : null,
    )
    .filter(Boolean) as Facilities

  event.formData.append('facilities', JSON.stringify(activeFacilities))
  event.formData.append('oldFacilities', JSON.stringify(oldFacilities))
}
